import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import chatList, { getChatListSaga } from 'modules/actions/chat';
import fontSize from 'modules/actions/fontSize';
import { sendSatisfyactionSaga } from 'modules/actions/starScore';
import organizationResult, { sendOrganizationSaga } from 'modules/actions/sendOrganization';
import autoComplete, { autoCompleteSaga } from 'modules/actions/autoComplete/index';
import isActive from 'modules/actions/statusMenu/index';
import quality, { getQualityOptions, sendQualityGenerator } from 'modules/actions/quality';
import supportSystem from 'modules/actions/supportSystem';
import searchAddr from 'modules/actions/searchAddr';

const rootReducer = combineReducers({
  autoComplete,
  isActive,
  chatList,
  fontSize,
  quality,
  supportSystem,
  searchAddr,
  organizationResult,
});

export function* rootSaga() {
  yield all([autoCompleteSaga(), getChatListSaga(), sendSatisfyactionSaga(), getQualityOptions(), sendQualityGenerator(), sendOrganizationSaga()]);
}

export default rootReducer;
